import * as React from 'react'
import { ConnectionStatusType } from '@/types'
import { createFileRoute } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import {
  DialogClose,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog'
import EditConnectionStatusForm from '@/components/forms/edit-connection-status'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/connection-status/edit',
)({
  component: EditConnectionStatusPage,
})

export default function EditConnectionStatusPage({
  connectionStatusData,
  setShowEditConnectionStatusModal,
}: {
  connectionStatusData: ConnectionStatusType
  setShowEditConnectionStatusModal: React.Dispatch<
    React.SetStateAction<boolean>
  >
}) {
  return (
    <main>
      {/* <DialogContent className="md:max-w-[850px]">
        <EditConnectionStatusForm />
        <DialogFooter className="flex flex-row justify-end gap-2 md:mr-4">
          <DialogClose>
            <Button variant="outline" type="submit" className="w-28">
              Cancel
            </Button>
          </DialogClose>
          <Button type="submit" className="w-28">
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent> */}
      <CredenzaContent className="flex w-full max-w-[850px] justify-center">
        <CredenzaBody>
          <EditConnectionStatusForm
            connectionStatusData={connectionStatusData}
            setShowEditConnectionStatusModal={setShowEditConnectionStatusModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
